<template>
  <div class="sign-pg">
    <div class="sign-row">
      <div class="confirm-email">
        <p>
          {{
            $t("Регистрация прошла успешно. Пожалуйста, проверьте свою электронную почту и подтвердите регистрацию на Едином портале, пройдя по ссылке в письме, которое мы вам направим в течение 3 минут.")
          }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import {Trans} from "@/plugins/Translation"

export default {
  created() {
    this.scrollToTop()
  },
  methods: {
    async logout() {
      await this.$store.dispatch('logout')
      this.$router.push(Trans.i18nRoute({name: 'login', query: {message: 'logout'}}))
    },
    scrollToTop() {
      window.scrollTo(0, 0)
    }
  }
}
</script>
